(function () {
  'use strict';

  /* Inject swatch styles */
  var style = document.createElement('style');
  style.textContent = [
    '.i-swatch-option-label{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:#5C4F3D;font-family:"Inter",sans-serif;margin-bottom:12px;display:block;}',
    '.i-swatch-option-value{color:#1C1610;}',
    '.i-swatch-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:20px;width:100%;max-width:100%;box-sizing:border-box;overflow:hidden;}',
    '.i-swatch-card{border:2px solid #D4C9B5;border-radius:6px;overflow:hidden;cursor:pointer;display:flex;flex-direction:column;transition:border-color .2s;min-width:0;position:relative;width:100%;}',
    '.i-swatch-card:hover{border-color:#B5623F;}',
    '.i-swatch-card.active{border-color:#8C4A2F;}',
    '.i-swatch-card.active::after{content:"✓";position:absolute;top:6px;right:6px;width:22px;height:22px;background:#8C4A2F;color:#F5F0E8;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;}',
    '.i-swatch-img{width:100%;aspect-ratio:1;object-fit:cover;display:block;}',
    '.i-swatch-no-img{background:#EDE7DA;}',
    '.i-swatch-label{font-family:"Cormorant Garamond",Georgia,serif;font-size:13px;font-weight:600;text-align:center;color:#1C1610;padding:6px 4px;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
  ].join('');
  document.head.appendChild(style);

  function init() {
    if (!window.location.pathname.includes('/products/')) return;

    var parts = window.location.pathname.replace(/\/$/, '').split('/');
    var idx = parts.indexOf('products');
    if (idx === -1) return;
    var handle = (parts[idx + 1] || '').split('?')[0];
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { buildSwatches(product); })
      .catch(function (e) { console.warn('Incasso swatches fetch error:', e); });
  }

  function buildSwatches(product) {
    if (!product || !product.variants) return;

    /* Find color option index */
    var colorIdx = 0;
    if (product.options) {
      product.options.forEach(function (name, i) {
        var n = name.toLowerCase();
        if (n.indexOf('color') > -1 || n.indexOf('colour') > -1 || n.indexOf('цвят') > -1) {
          colorIdx = i;
        }
      });
    }

    /* Build unique color + image list */
    var seen = {};
    var colors = [];
    product.variants.forEach(function (v) {
      var name = v.options[colorIdx];
      if (!seen[name]) {
        seen[name] = true;
        colors.push({
          name: name,
          image: v.featured_image ? v.featured_image.src : null
        });
      }
    });

    if (!colors.length) return;

    /* Find the native picker fieldset */
    var picker =
      document.querySelector('.product-form__input--swatch') ||
      document.querySelector('.product-form__input--pill') ||
      document.querySelector('variant-selects fieldset') ||
      document.querySelector('variant-radios fieldset');

    if (!picker) return;

    /* Walk UP to find the variant-selects / variant-radios wrapper
       so we insert our grid OUTSIDE the custom element.
       This stops Dawn re-rendering from removing our grid. */
    var insertBefore = picker;
    var el = picker.parentElement;
    while (el) {
      var tag = el.tagName ? el.tagName.toLowerCase() : '';
      if (tag === 'variant-selects' || tag === 'variant-radios') {
        insertBefore = el;
        break;
      }
      el = el.parentElement;
    }

    /* Don't insert twice */
    if (insertBefore.parentNode.querySelector('.i-swatch-grid')) return;

    /* Build the grid */
    var grid = document.createElement('div');
    grid.className = 'i-swatch-grid';

    /* Color name label above grid */
    var colorLabel = document.createElement('div');
    colorLabel.className = 'i-swatch-option-label';
    colorLabel.textContent = product.options[colorIdx] + ': ';
    var colorValue = document.createElement('span');
    colorValue.className = 'i-swatch-option-value';
    colorValue.textContent = colors[0].name;
    colorLabel.appendChild(colorValue);

    colors.forEach(function (c, i) {
      var card = document.createElement('div');
      card.className = 'i-swatch-card' + (i === 0 ? ' active' : '');
      card.dataset.value = c.name;

      if (c.image) {
        var img = document.createElement('img');
        img.src = c.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2');
        img.alt = c.name;
        img.className = 'i-swatch-img';
        card.appendChild(img);
      } else {
        var block = document.createElement('div');
        block.className = 'i-swatch-img i-swatch-no-img';
        card.appendChild(block);
      }

      var label = document.createElement('span');
      label.className = 'i-swatch-label';
      label.textContent = c.name;
      card.appendChild(label);

      card.addEventListener('click', function () {
        /* Trigger the native radio so Dawn updates gallery + cart */
        var radios = picker.querySelectorAll('input[type="radio"]');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].value === c.name) {
            radios[j].checked = true;
            radios[j].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
        document.querySelectorAll('.i-swatch-card').forEach(function (el) {
          el.classList.remove('active');
        });
        card.classList.add('active');
        colorValue.textContent = c.name;
      });

      grid.appendChild(card);
    });

    /* Insert label + grid before the custom element, hide native picker */
    insertBefore.parentNode.insertBefore(colorLabel, insertBefore);
    insertBefore.parentNode.insertBefore(grid, insertBefore);
    insertBefore.style.cssText = 'position:absolute;opacity:0;pointer-events:none;height:0;overflow:hidden;';
  }

  /* Wait 1000ms to ensure Dawn custom elements are fully initialised */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 1000);
    });
  } else {
    setTimeout(init, 1000);
  }

})();